import ApiService from '@/services/api.service'
import * as Sentry from "@sentry/vue";

export const requestMixin = {
  methods: {
    async request(url, params = {}) {
      try {
        const res = await ApiService.customRequest({
          url,
          ...params,
        });

        return [res.data, null, res];
      } catch (err) {
        Sentry.captureException(err);
        
        return [null, err];
      }
    },
    getRequestErrorMessage(error) {

      if (!error.response) {
        return error
      }
      
      if (error.response.status === 422) {
        return error.response.data.errors[0].detail;
      } else if (error.response.status === 400) {
        return error.response.data.errors[0].detail;
      } else if (error.response.status === 429) {
        return 'Terlalu banyak permintaan';
      } else if (error.response.status === 500) {
        return 'Terjadi kesalahan pada sistem. Silakan hubungi administrator.';
      } else {
        return error;
      }
    },
  },
};
